module.exports = __webpack_public_path__ + "static/calendar-calculator-7f846ec9946497712564d7e0871c552f.jpg";